// @flow

export function isWindows10() {
   return !!navigator.userAgent.match(/(Windows NT 10)/i);
}
